import { addDays, format, isAfter, isBefore, isEqual } from "date-fns";
import { useMemo } from "react";
export function useVerticalExternalTimelineProcessController(_a) {
    var data = _a.data;
    var initialSteps = [
        {
            key: "dataProcesso",
            name: "Abertura do Processo",
            description: "",
            type: "process",
        },
        {
            key: "dataPagamento",
            name: "Pagamento",
            description: "",
            type: "process",
        },
        {
            key: "dataHabilitado",
            name: "Autorização da emissão",
            description: "Data que o detran liberou a autorização de emissão",
            type: "process",
        },
        {
            key: "dataEmissaoCnh",
            name: "CNH emitida",
            description: "Data que a gráfica emitiu a CNH",
            type: "process",
        },
    ];
    function transformToValidDate(date, isTimestamp) {
        if (isTimestamp === void 0) { isTimestamp = false; }
        if (date == null)
            throw new Error("Data não pode ser nula.");
        if (typeof date === "number")
            date = date.toString();
        var _a = [
            date.slice(0, 4),
            date.slice(4, 6),
            date.slice(6, 8),
        ], ano = _a[0], mes = _a[1], dia = _a[2];
        var formattedValue = isTimestamp
            ? new Date("".concat(ano, "-").concat(mes, "-").concat(dia, "T00:00:00"))
            : new Date("".concat(ano, "-").concat(mes, "-").concat(dia));
        return formattedValue;
    }
    function formatDateToBrazilianPattern(date) {
        if (date == null)
            return "---";
        var validDate = transformToValidDate(date);
        return format(validDate, "dd/MM/yyyy");
    }
    /**
     *
     * @param firstDate
     * @param dateToCompare
     * @returns boolean
     */
    function isDateBeforeSecondDate(firstDate, dateToCompare) {
        if (firstDate == null || dateToCompare == null)
            return false;
        var validFirstDate = transformToValidDate(firstDate);
        var validDateToCompare = transformToValidDate(dateToCompare);
        if (isEqual(validFirstDate, validDateToCompare))
            return true;
        return isBefore(validFirstDate, validDateToCompare);
    }
    function isAttrDateNull(attrKey) {
        return findAttributeDateValue(attrKey) == null;
    }
    function findAttributeDateValue(attrKey) {
        var _a, _b, _c;
        var isExam = ((_a = steps.find(function (item) { return item.key === attrKey; })) === null || _a === void 0 ? void 0 : _a.type) === "exam";
        return isExam
            ? ((_c = (_b = data.exames) === null || _b === void 0 ? void 0 : _b.find(function (exam) { return (exam === null || exam === void 0 ? void 0 : exam.tipoExameDescricao) === attrKey; })) === null || _c === void 0 ? void 0 : _c.data) || null
            : data[attrKey];
    }
    function findExamResult(attrKey) {
        var _a;
        return (_a = data.exames) === null || _a === void 0 ? void 0 : _a.find(function (exam) { return (exam === null || exam === void 0 ? void 0 : exam.tipoExameDescricao) === attrKey; });
    }
    var steps = useMemo(function () {
        var _a, _b, _c, _d;
        var shouldDisplayBiometricStep = isDateBeforeSecondDate(data === null || data === void 0 ? void 0 : data.dataProcesso, data === null || data === void 0 ? void 0 : data.dataCaptura);
        var shouldDisplayLocalExamsSteps = ((_a = data === null || data === void 0 ? void 0 : data.distribuicaoEquitativa) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = data === null || data === void 0 ? void 0 : data.exames) === null || _b === void 0 ? void 0 : _b.length) === 0;
        var shouldDisplayResultExamsSteps = !!((_c = data === null || data === void 0 ? void 0 : data.exames) === null || _c === void 0 ? void 0 : _c.length);
        var modifiedSteps = initialSteps;
        // Index in four or third or fourth position
        var indexToAdd = shouldDisplayBiometricStep ? 3 : 2;
        if (shouldDisplayBiometricStep) {
            modifiedSteps.splice(2, 0, {
                key: "dataCaptura",
                name: "Captura da biometria",
                description: "",
                type: "process",
            });
        }
        if (shouldDisplayLocalExamsSteps) {
            data === null || data === void 0 ? void 0 : data.distribuicaoEquitativa.forEach(function (item) {
                if (item.tipo === "M") {
                    modifiedSteps.splice(indexToAdd, 0, {
                        key: "Aptidão Física E Mental",
                        name: "Avaliação Física",
                        description: "",
                        type: "exam",
                    });
                    indexToAdd++;
                }
                if (item.tipo === "P") {
                    modifiedSteps.splice(indexToAdd, 0, {
                        key: "Avaliação Psicológica",
                        name: "Avaliação Psicológica",
                        description: "",
                        type: "exam",
                    });
                    indexToAdd++;
                }
                // Para algum tipo de exame não mapeado
                if (item.tipo !== "M" && item.tipo !== "P") {
                    modifiedSteps.splice(indexToAdd, 0, {
                        key: "Exame ".concat(item.tipoEspecialidade),
                        name: "Exame ".concat(item.tipoEspecialidade),
                        description: "",
                        type: "exam",
                    });
                    indexToAdd++;
                }
            });
        }
        else if (shouldDisplayResultExamsSteps) {
            (_d = data === null || data === void 0 ? void 0 : data.exames) === null || _d === void 0 ? void 0 : _d.forEach(function (item) {
                if (item.tipoExameDescricao === "Aptidão Física E Mental") {
                    modifiedSteps.splice(indexToAdd, 0, {
                        key: "Aptidão Física E Mental",
                        name: "Avaliação Física",
                        description: "",
                        type: "exam",
                    });
                    indexToAdd++;
                }
                if (item.tipoExameDescricao === "Avaliação Psicológica") {
                    modifiedSteps.splice(indexToAdd, 0, {
                        key: "Avaliação Psicológica",
                        name: "Avaliação Psicológica",
                        description: "",
                        type: "exam",
                    });
                    indexToAdd++;
                }
                // Para algum tipo de exame não mapeado
                if (item.tipoExameDescricao !== "Aptidão Física E Mental" &&
                    item.tipoExameDescricao !== "Avaliação Psicológica") {
                    modifiedSteps.splice(indexToAdd, 0, {
                        key: item.tipoExameDescricao,
                        name: item.tipoExameDescricao,
                        description: "",
                        type: "exam",
                    });
                    indexToAdd++;
                }
            });
        }
        return modifiedSteps;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data.atividaderemunerada,
        data.codigoRequerimento,
        data.dataCaptura,
        data.dataProcesso,
    ]);
    var isLastStep = function (currentIndex) {
        return steps.length === currentIndex + 1;
    };
    function mustDisplayLocalExams(attrKey) {
        var _a, _b;
        return (((_a = data === null || data === void 0 ? void 0 : data.distribuicaoEquitativa) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            !!(data === null || data === void 0 ? void 0 : data.dataPagamento) &&
            !((_b = findExamResult(attrKey)) === null || _b === void 0 ? void 0 : _b.data));
    }
    function mustDisplayMessageGotoDetran(attrKey) {
        return (attrKey === "dataCaptura" &&
            !!data.dataPagamento &&
            !!!data.dataCaptura &&
            data.replicaBioRg &&
            isAfter(new Date(), addDays(transformToValidDate(data.dataPagamento, true), 3)));
    }
    return {
        steps: steps,
        mustDisplayLocalExams: mustDisplayLocalExams,
        mustDisplayMessageGotoDetran: mustDisplayMessageGotoDetran,
        isLastStep: isLastStep,
        findExamResult: findExamResult,
        isAttrDateNull: isAttrDateNull,
        findAttributeDateValue: findAttributeDateValue,
        formatDateToBrazilianPattern: formatDateToBrazilianPattern,
        isDateBeforeSecondDate: isDateBeforeSecondDate,
        transformToValidDate: transformToValidDate,
    };
}
